import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { computed, flow, makeObservable } from "mobx";
import { AbstractCategoryCollection, ClientCollection, RouteHttpVerb } from "@devowl-wp/utils";
import { CookieGroupModel } from "./cookieGroupModel.js";
import { request } from "../utils/request.js";
import { locationRestCookieGroupOrderPut } from "../wp-api/cookieGroupOrder.put.js";
class CookieGroupCollection extends AbstractCategoryCollection {
    store;
    get sortedGroups() {
        const result = Array.from(this.entries.values());
        result.sort((a, b)=>{
            if (a.data.meta.order < b.data.meta.order) {
                return -1;
            } else if (a.data.meta.order > b.data.meta.order) {
                return 1;
            } else {
                return 0;
            }
        });
        return result;
    }
    constructor(store){
        super();
        makeObservable(this);
        this.store = store;
    }
    orderCookieGroups = flow(function*(ids) {
        this.busy = true;
        try {
            yield request({
                location: locationRestCookieGroupOrderPut,
                request: {
                    ids
                }
            });
            // Apply the order to existing cached models instead of fetching again
            let i = 0;
            for (const id of ids){
                const group = this.entries.get(id);
                group.setOrder(i);
                i++;
            }
        } catch (e) {
            console.log(e);
            throw e;
        } finally{
            this.busy = false;
        }
    });
    instance(response) {
        return new CookieGroupModel(this).fromResponse(response);
    }
}
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], CookieGroupCollection.prototype, "sortedGroups", null);
CookieGroupCollection = _ts_decorate([
    ClientCollection.annotate({
        path: "/rcb-cookie-group",
        singlePath: "/rcb-cookie-group/:id",
        namespace: "wp/v2",
        methods: [
            RouteHttpVerb.GET
        ],
        request
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof CookieStore === "undefined" ? Object : CookieStore
    ])
], CookieGroupCollection);
export { CookieGroupCollection };
